import _classCallCheck from "/root/workspace/orca-official-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/root/workspace/orca-official-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/root/workspace/orca-official-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/root/workspace/orca-official-site/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _createForOfIteratorHelper from "/root/workspace/orca-official-site/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import * as React from "react";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
function traverseFiber(fiber, ascending, selector) {
  if (!fiber) return;
  if (selector(fiber) === true) return fiber;
  var child = ascending ? fiber.return : fiber.child;
  while (child) {
    var match = traverseFiber(child, ascending, selector);
    if (match) return match;
    child = ascending ? null : child.sibling;
  }
}
function wrapContext(context) {
  try {
    return Object.defineProperties(context, {
      _currentRenderer: {
        get: function get() {
          return null;
        },
        set: function set() {}
      },
      _currentRenderer2: {
        get: function get() {
          return null;
        },
        set: function set() {}
      }
    });
  } catch (_) {
    return context;
  }
}
var FiberContext = wrapContext(React.createContext(null));
var FiberProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(FiberProvider, _React$Component);
  var _super = _createSuper(FiberProvider);
  function FiberProvider() {
    _classCallCheck(this, FiberProvider);
    return _super.apply(this, arguments);
  }
  _createClass(FiberProvider, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */React.createElement(FiberContext.Provider, {
        value: this._reactInternals
      }, this.props.children);
    }
  }]);
  return FiberProvider;
}(React.Component);
var _React$__SECRET_INTER = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  ReactCurrentOwner = _React$__SECRET_INTER.ReactCurrentOwner,
  ReactCurrentDispatcher = _React$__SECRET_INTER.ReactCurrentDispatcher;
function useFiber() {
  var root = React.useContext(FiberContext);
  if (!root) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
  var id = React.useId();
  var fiber = React.useMemo(function () {
    var _a;
    return (_a = ReactCurrentOwner.current) != null ? _a : traverseFiber(root, false, function (node) {
      var state = node.memoizedState;
      while (state) {
        if (state.memoizedState === id) return true;
        state = state.next;
      }
    });
  }, [root, id]);
  return fiber;
}
function useContainer() {
  var fiber = useFiber();
  var root = React.useMemo(function () {
    return traverseFiber(fiber, true, function (node) {
      var _a;
      return ((_a = node.stateNode) == null ? void 0 : _a.containerInfo) != null;
    });
  }, [fiber]);
  return root == null ? void 0 : root.stateNode.containerInfo;
}
function useNearestChild(type) {
  var fiber = useFiber();
  var childRef = React.useRef();
  React.useLayoutEffect(function () {
    var _a;
    childRef.current = (_a = traverseFiber(fiber, false, function (node) {
      return typeof node.type === "string" && (type === void 0 || node.type === type);
    })) == null ? void 0 : _a.stateNode;
  }, [fiber]);
  return childRef;
}
function useNearestParent(type) {
  var fiber = useFiber();
  var parentRef = React.useRef();
  React.useLayoutEffect(function () {
    var _a;
    parentRef.current = (_a = traverseFiber(fiber, true, function (node) {
      return typeof node.type === "string" && (type === void 0 || node.type === type);
    })) == null ? void 0 : _a.stateNode;
  }, [fiber]);
  return parentRef;
}
var contexts = [];
var values = /* @__PURE__ */new WeakMap();
function useContextBridge() {
  var _a;
  var fiber = useFiber();
  contexts.splice(0, contexts.length);
  traverseFiber(fiber, true, function (node) {
    var _a2;
    var context = (_a2 = node.type) == null ? void 0 : _a2._context;
    if (context && context !== FiberContext) contexts.push(wrapContext(context));
  });
  var _iterator2 = _createForOfIteratorHelper(contexts),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var context = _step2.value;
      var value = (_a = ReactCurrentDispatcher.current) == null ? void 0 : _a.readContext(context);
      values.set(context, value);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return React.useMemo(function () {
    return contexts.reduce(function (Prev, context) {
      return function (props) {
        return /* @__PURE__ */React.createElement(Prev, null, /* @__PURE__ */React.createElement(context.Provider, __spreadProps(__spreadValues({}, props), {
          value: values.get(context)
        })));
      };
    }, function (props) {
      return /* @__PURE__ */React.createElement(FiberProvider, __spreadValues({}, props));
    });
  }, []);
}
export { FiberProvider, traverseFiber, useContainer, useContextBridge, useFiber, useNearestChild, useNearestParent };